<div style="height: 200px !important;" class="h-100 d-flex flex-column justify-content-between">
  <div class="search-container">
    <!-- Child emits the selected location -->
    <app-locations-autocomplete
      class="search-input"
      (predictionSelected)="onLocationSelected($event)">
    </app-locations-autocomplete>
    <div class="selected-location" *ngIf="selectedLocation">
      <!-- Display the selected location -->
      <p>{{ selectedLocation }}</p>
    </div>
  </div>

  
</div>
